import { render, staticRenderFns } from "./_bank.vue?vue&type=template&id=548f639a&scoped=true&lang=pug&"
import script from "./_bank.vue?vue&type=script&lang=js&"
export * from "./_bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548f639a",
  null
  
)

export default component.exports